import Big from 'big.js';
import _ from 'lodash';
import {
  getAuth,
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  onValue,
  update,
  push,
  get,
  child,
  query as dbQuery,
  orderByChild,
  startAt,
  endAt,
  orderByKey,
  equalTo,
  limitToLast,
} from 'firebase/database';
import moment from 'moment-timezone';
import {
  all,
  takeEvery,
  takeLatest,
  put,
  call,
  fork,
  select,
  take,
} from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import actions from './actions';
import appActions from '../app/actions';
import authActions from '../auth/actions';
import financialActions from '../financial/actions';

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

// Teto do histórico do drawer de fornecedor: a tela mostra 6 e avisa quando há mais.
const PROVIDER_HISTORY_LIMIT = 13;

const getUnifiedTokenStore = (state) => state.Auth.unified;

const getMainUserFromStore = (state) => state.Auth.mainUser;

const getSelectedAddressFromStore = (state) => state.App.selectedAddress;

const getInventoryOpsListenerTimeFromStore = (state) => state.Inventory.inventoryOpsListenerTime;

const getInventoryOpsListenerCustomTimeFromStore = (state) => state.Inventory.inventoryOpsListenerCustomTime;

const getInventoryOpsListenerTimeRangeFromStore = (state) => state.Inventory.inventoryOpsListenerTimeRange;

const getFinancialContactsFromStore = (state) => state.Financial.financialContacts;

const getInventoryNewBatchesFromStore = (state) => state.Inventory.inventoryNewBatches || [];

const getInventoryStockFromStore = (state) => state.Inventory.inventoryStock || [];

const getInventoryItemsFromStore = (state) => state.Inventory.inventoryItems || [];

const getInventoryWarehousesFromStore = (state) => state.Inventory.inventoryWarehouses || [];

function computeItemAmountFromStock(itemId, stock) {
  return (stock || [])
    .filter((l) => l.itemId === itemId)
    .reduce((sum, l) => sum + (l.amount || 0), 0);
}

function getInventorySettingsFromDB(addressUid, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `inventory/${uid}/${addressUid}/settings`));
}

export function* getInventorySettingsRequest() {
  yield takeLatest(actions.GET_INVENTORY_SETTINGS_REQUEST, function* () {
    try {
      // yield put({ type: actions.CHECKING_FINANCIAL_PAYMENTS });
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const settings = yield call(
        getInventorySettingsFromDB,
        addressUid,
        mainUser,
      );
      const auth = getAuth();
      const { currentUser } = auth;
      const obj = {
        invoiceAutomation: false,
        showFinalizedAppointmentModal: {
          [currentUser.uid]: false,
        },
      };
      if (settings.val()) {
        _.merge(obj, settings.val());
      }
      yield put({
        type: actions.GET_INVENTORY_SETTINGS_SUCCESS,
        // payload: {
        //   invoiceAutomation: invoiceAutomation.val(),
        //   address: addressUid,
        // },
        payload: {
          inventorySettings: obj,
          address: addressUid,
        },
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_INVENTORY_SETTINGS_ERROR,
      });
    }
  });
}

function saveInvoiceAutomationOnDB(value, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/inventory/${uid}/${currentAddress}/settings/invoiceAutomation`] = value;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* changeInvoiceAutomationRequest() {
  yield takeLatest(actions.CHANGE_INVENTORY_INVOICE_AUTOMATION_REQUEST, function* (action) {
    try {
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        saveInvoiceAutomationOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_INVENTORY_SETTINGS_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CHANGE_INVENTORY_INVOICE_AUTOMATION_ERROR,
      });
    }
  });
}

function saveShowFinalizedAppointmentModalOnDB(value, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  const auth = getAuth();
  const { currentUser } = auth;
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/inventory/${uid}/${currentAddress}/settings/showFinalizedAppointmentModal/${currentUser.uid}`] = value;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* changeShowFinalizedAppointmentModalRequest() {
  yield takeLatest(actions.CHANGE_INVENTORY_SHOW_FINALIZED_APPOINTMENT_MODAL_REQUEST, function* (action) {
    try {
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        saveShowFinalizedAppointmentModalOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_INVENTORY_SETTINGS_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CHANGE_INVENTORY_SHOW_FINALIZED_APPOINTMENT_MODAL_ERROR,
      });
    }
  });
}

function depositInventoryItemOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  const auth = getAuth();
  const { currentUser } = auth;
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  const updates = {};
  if (values.products) {
    const pushKey = push(child(ref(db), `/inventory/${uid}/${currentAddress}/ops`)).key;
    updates[`/inventory/${uid}/${currentAddress}/ops/${pushKey}`] = {
      ...values,
      id: null,
      // products: null,
      // itemId: el.id,
      type: 'deposit',
      user: currentUser.uid,
    };
    // values.products.forEach((el) => {
    //   const pushKey = db.ref().child(`/inventory/${uid}/${currentAddress}/ops`).push().key;
    //   updates[`/inventory/${uid}/${currentAddress}/ops/${pushKey}`] = {
    //     ...values,
    //     ...el,
    //     id: null,
    //     products: null,
    //     itemId: el.id,
    //     type: 'deposit',
    //     user: firebase.auth().currentUser.uid,
    //   };
    // });
  } else {
    throw new Error('No products!');
  }
  // return true;
  return update(dbRef, updates);
}

function createInventoryOnDB(item, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/inventory/${uid}/${currentAddress}/items`)).key;
  updates[`/inventory/${uid}/${currentAddress}/items/${pushKey}`] = item;
  return update(dbRef, updates).then(() => pushKey);
}

export function* createInventoryItemRequest() {
  yield takeLatest(actions.CREATE_INVENTORY_ITEM_REQUEST, function* (action) {
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const { initialStock, ...item } = action.payload;
      const itemId = yield call(createInventoryOnDB, item, currentAddress, mainUser);
      if (initialStock?.amount > 0 && itemId) {
        yield call(
          depositInventoryItemOnDB,
          {
            warehouseId: initialStock.warehouseId || null,
            desc: 'Saldo inicial',
            timestamp: moment().tz('America/Sao_Paulo').format(),
            products: [{
              key: 0,
              id: itemId,
              amount: initialStock.amount,
              unitValue: initialStock.unitValue || 0,
              batchNumber: '',
              expirationDate: '',
            }],
          },
          currentAddress,
          mainUser,
        );
      }
      yield put({
        type: actions.CREATE_INVENTORY_ITEM_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_INVENTORY_ITEM_ERROR,
      });
    }
  });
}

// function getInventoryOpsFromDB(currentAddress, mainUser) {
//   let uid;
//   if (mainUser) {
//     uid = mainUser;
//   } else {
//     const { currentUser } = firebase.auth();
//     ({ uid } = currentUser);
//   }
//   const db = firebase.database();
//   return db.ref(`inventory/${uid}/${currentAddress}/ops`).once('value');
// }

function getTransactionFromDB(transactionId, costCenterProfile, addressUid, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const databaseRef = ref(db, `financial/${uid}/${addressUid}/transactions/${costCenterProfile}`);
  return get(dbQuery(
    databaseRef,
    orderByKey(),
    equalTo(transactionId),
  ));
}

function* fetchTransactionsArray(arr, addressId, mainUser) {
  return yield all(arr.map((s) => call(getTransactionFromDB, s.key, s.costCenterKey, addressId, mainUser)));
}

function createInventoryOpsListener(addressUid, mainUser, time, timeRange = []) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  if (timeRange?.length > 0) {
    const [startToUse, endToUse] = timeRange;
    const listener = eventChannel((emit) => {
      const databaseRef = ref(db, `inventory/${uid}/${addressUid}/ops`);
      const queryRef = dbQuery(
        databaseRef,
        orderByChild('timestamp'),
        startAt(startToUse),
        endAt(`${endToUse}\uf8ff`),
      );
      const unsubscribe = onValue(queryRef, (req) => (
        emit(req.val() || {})
      ));
      return () => unsubscribe();
    });
    return listener;
  }
  const startToUse = moment()
    .tz('America/Sao_Paulo')
    .subtract(time || 1, 'months')
    .format('YYYY-MM-DD');
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `inventory/${uid}/${addressUid}/ops`);
    const queryRef = dbQuery(
      databaseRef,
      orderByChild('timestamp'),
      startAt(startToUse),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

function fetchPatientDataFromDB(patientId, addressUid, unified = {}, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    return get(child(dbRef, `/unified/${unified.id}/patients/${patientId}`));
  }
  return get(child(dbRef, `/users/${uid}/patients/${patientId}`));
}

export function* getInventoryOpsRequest() {
  let currentListener = null;
  yield takeLatest([
    // actions.INVENTORY_FETCH_REQUEST,
    actions.INVENTORY_OPS_FETCH_REQUEST,
  ], function* () {
    try {
      if (currentListener) {
        currentListener.close();
        currentListener = null;
      }
      yield put({ type: actions.FETCHING_INVENTORY_OPS_LIST });
      let addressUid = yield select(getSelectedAddressFromStore);
      if (!addressUid) {
        yield take(appActions.SELECT_ADDRESS);
        addressUid = yield select(getSelectedAddressFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      const listenerTime = yield select(getInventoryOpsListenerTimeFromStore);
      const listenerCustomTime = yield select(getInventoryOpsListenerCustomTimeFromStore);
      const listenerTimeRange = yield select(getInventoryOpsListenerTimeRangeFromStore);
      currentListener = yield call(
        createInventoryOpsListener,
        addressUid,
        mainUser,
        listenerCustomTime || listenerTime,
        listenerTimeRange,
      );
      yield takeEvery(currentListener, function* (manualOps) {
        const inventoryOpsArr = _.map(manualOps, (val, opsId) => (
          {
            ...val,
            id: opsId,
          }
        ));
        const transactionsArr = [];
        inventoryOpsArr.forEach((el) => {
          if (el.transactions) {
            Object.keys(el.transactions).forEach((costCenterKey) => {
              Object.keys(el.transactions[costCenterKey]).forEach((transactionKey) => {
                transactionsArr.push({
                  key: transactionKey,
                  costCenterKey,
                });
              });
            });
          }
        });
        const unified = yield select(getUnifiedTokenStore);
        // for (const ops of inventoryOpsArr) {
        for (let i = 0; i < inventoryOpsArr.length; i += 1) {
          if (inventoryOpsArr[i].patient) {
            const userInfo = yield call(
              fetchPatientDataFromDB,
              inventoryOpsArr[i].patient,
              addressUid,
              unified,
              mainUser,
            );
            if (userInfo.val()) {
              inventoryOpsArr[i].userInfo = {
                ...userInfo.val(),
                id: userInfo.key,
              };
            }
          }
        }
        const transactionsResponses = yield call(fetchTransactionsArray, transactionsArr, addressUid, mainUser);
        transactionsResponses.forEach((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach((response) => {
              const transaction = response.val();
              const index = inventoryOpsArr.findIndex((el) => el.id === transaction.key);
              if (index > -1) {
                if (!inventoryOpsArr[index].transactionsArr) {
                  inventoryOpsArr[index].transactionsArr = [];
                }
                inventoryOpsArr[index].transactionsArr.push({
                  ...transaction,
                  id: response.key,
                });
              }
            });
          }
        });
        yield put({
          type: actions.INVENTORY_OPS_FETCH_SUCCESS,
          payload: {
            inventoryOpsArr,
            address: addressUid,
          },
        });
      });
      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        actions.CHANGE_INVENTORY_OPS_LISTENER_TIMER,
      ]);
      currentListener.close();
      currentListener = null;
      if (actionTriggered?.type === 'CHANGE_INVENTORY_OPS_LISTENER_TIMER') {
        // Resetting listener to filter new 'costProfile'.
        yield put({
          type: actions.INVENTORY_OPS_FETCH_REQUEST,
        });
      } else {
        // It is the general "cancel all listeners".
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_INVENTORY_OPS }),
        ]);
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.INVENTORY_OPS_FETCH_ERROR,
      });
    }
  });
}

function getInventoryProvidersFromDB(currentAddress, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `inventory/${uid}/${currentAddress}/providers`));
}

export function* getInventoryProvidersRequest() {
  yield takeLatest([
    actions.INVENTORY_FETCH_REQUEST,
    actions.INVENTORY_PROVIDERS_FETCH_REQUEST,
  ], function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      const inventory = yield call(getInventoryProvidersFromDB, currentAddress, mainUser);
      if (inventory.val()) {
        let inventoryProviders = [];
        if (inventory.val()) {
          inventoryProviders = _.map(inventory.val(), (val, providersId) => (
            { ...val, id: providersId }
          ));
        }
        yield put({
          type: actions.INVENTORY_PROVIDERS_FETCH_SUCCESS,
          payload: {
            inventoryProviders,
            address: currentAddress,
          },
        });
      } else {
        yield put({
          type: actions.INVENTORY_PROVIDERS_FETCH_SUCCESS,
          payload: {
            inventoryProviders: [],
            address: currentAddress,
          },
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.INVENTORY_FETCH_ERROR,
        payload: {
          address: currentAddress,
        },
      });
    }
  });
}

function getInventoryClassesFromDB(currentAddress, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `inventory/${uid}/${currentAddress}/classes`));
}

export function* getInventoryClassesRequest() {
  yield takeLatest([
    actions.INVENTORY_FETCH_REQUEST,
    actions.INVENTORY_CLASSES_FETCH_REQUEST,
  ], function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      const inventory = yield call(getInventoryClassesFromDB, currentAddress, mainUser);
      if (inventory.val()) {
        let inventoryClasses = [];
        if (inventory.val()) {
          inventoryClasses = _.map(inventory.val(), (val, classId) => (
            { ...val, id: classId }
          ));
        }
        yield put({
          type: actions.INVENTORY_CLASSES_FETCH_SUCCESS,
          payload: {
            inventoryClasses,
            address: currentAddress,
          },
        });
      } else {
        yield put({
          type: actions.INVENTORY_CLASSES_FETCH_SUCCESS,
          payload: {
            inventoryClasses: [],
            address: currentAddress,
          },
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.INVENTORY_FETCH_ERROR,
        payload: {
          address: currentAddress,
        },
      });
    }
  });
}

function createInventoryItemsListener(addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `inventory/${uid}/${addressUid}/items`);
    const unsubscribe = onValue(databaseRef, (req) => (
      emit(req.val() || 0)
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getInventoryItemsRequest() {
  let currentListener = null;
  yield takeLatest(actions.INVENTORY_ITEMS_LISTENER_REQUEST, function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    try {
      if (currentListener) {
        currentListener.close();
        currentListener = null;
      }
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      if (!getAuth().currentUser) return;
      currentListener = yield call(
        createInventoryItemsListener,
        currentAddress,
        mainUser,
      );
      yield takeEvery(currentListener, function* (items) {
        const currentStock = yield select(getInventoryStockFromStore);
        const normalizedInventoryItems = _.map(items, (val, itemId) => ({
          ...val,
          id: itemId,
          batches: null,
          amount: computeItemAmountFromStock(itemId, currentStock),
        }));
        yield put({
          type: actions.INVENTORY_ITEMS_FETCH_SUCCESS,
          payload: {
            inventoryItems: normalizedInventoryItems,
          },
        });
      });
      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        authActions.LOGOUT,
        authActions.CLEAR_STATES,
      ]);
      currentListener.close();
      currentListener = null;
      if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
        // Address change: selectAddress resubscribes via removeListeners.
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_INVENTORY_LISTENER }),
        ]);
      }
      // LOGOUT/CLEAR_STATES: keep listeners closed.
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.INVENTORY_FETCH_ERROR,
        payload: {
          address: currentAddress,
        },
      });
    }
  });
}

function createInventoryItemsBatchesListener(addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `inventory/${uid}/${addressUid}/itemsBatches`);
    const queryRef = dbQuery(
      databaseRef,
      orderByChild('amount'),
      startAt(1),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || 0)
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getInventoryItemsBatchesRequest() {
  let currentListener = null;
  yield takeLatest(actions.INVENTORY_ITEMS_LISTENER_REQUEST, function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    try {
      if (currentListener) {
        currentListener.close();
        currentListener = null;
      }
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      if (!getAuth().currentUser) return;
      currentListener = yield call(
        createInventoryItemsBatchesListener,
        currentAddress,
        mainUser,
      );
      yield takeEvery(currentListener, function* (items) {
        const normalizedInventoryItemsBatches = _.map(items, (val, id) => (
          { ...val, id }
        ));
        yield put({
          type: actions.INVENTORY_ITEMS_BATCHES_FETCH_SUCCESS,
          payload: {
            inventoryItemsBatches: normalizedInventoryItemsBatches || [],
          },
        });
      });
      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        authActions.LOGOUT,
        authActions.CLEAR_STATES,
      ]);
      currentListener.close();
      currentListener = null;
      if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
        // Address change: selectAddress resubscribes via removeListeners.
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_INVENTORY_LISTENER }),
        ]);
      }
      // LOGOUT/CLEAR_STATES: keep listeners closed.
    } catch (error) {
      console.warn(error);
      // yield put({
      //   type: actions.INVENTORY_FETCH_ERROR,
      //   payload: {
      //     address: currentAddress,
      //   },
      // });
    }
  });
}

function removeInventoryOnDB(key, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/inventory/${uid}/${currentAddress}/items/${key}/disabled`] = true;
  return update(dbRef, updates);
}

export function* removeInventoryRequest() {
  yield takeLatest(actions.REMOVE_INVENTORY_ITEM_REQUEST, function* (action) {
    const currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      const mainUser = yield select(getMainUserFromStore);
      yield call(removeInventoryOnDB, action.payload, currentAddress, mainUser);
      yield put({
        type: actions.REMOVE_INVENTORY_ITEM_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.REMOVE_INVENTORY_ITEM_ERROR,
      });
    }
  });
}

export function* depositInventoryItemRequest() {
  yield takeLatest(actions.DEPOSIT_INVENTORY_ITEM_REQUEST, function* (action) {
    const currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.WAITING_INVENTORY_OPS });
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        depositInventoryItemOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.DEPOSIT_INVENTORY_ITEM_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.DEPOSIT_INVENTORY_ITEM_ERROR,
      });
    }
  });
}

function createProviderOnDB(item, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/inventory/${uid}/${currentAddress}/providers`)).key;
  updates[`/inventory/${uid}/${currentAddress}/providers/${pushKey}`] = item;
  return update(dbRef, updates);
}

export function* createInventoryProviderRequest() {
  yield takeLatest(actions.CREATE_INVENTORY_PROVIDER_REQUEST, function* (action) {
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(createProviderOnDB, action.payload, currentAddress, mainUser);
      yield put({
        type: actions.INVENTORY_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_INVENTORY_PROVIDER_ERROR,
      });
    }
  });
}

function removeProviderOnDB(key, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/inventory/${uid}/${currentAddress}/providers/${key}/disabled`] = true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* removeInventoryProviderRequest() {
  yield takeLatest(actions.REMOVE_INVENTORY_PROVIDER_REQUEST, function* (action) {
    try {
      yield put({
        type: actions.INVENTORY_REMOVE_PROVIDER_WAITING,
        payload: action.payload,
      });
      yield call(sleep, 500);
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(removeProviderOnDB, action.payload, currentAddress, mainUser);
      yield put({
        type: actions.INVENTORY_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.REMOVE_INVENTORY_PROVIDER_ERROR,
      });
    }
  });
}

function updateProviderOnDB(key, item, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  // Campo a campo: os agregados de compra ficam em providers/{key}/stats e um
  // write do objeto inteiro apagaria o nó.
  updates[`/inventory/${uid}/${currentAddress}/providers/${key}/name`] = item.name;
  updates[`/inventory/${uid}/${currentAddress}/providers/${key}/cnpj`] = item.cnpj || null;
  return update(dbRef, updates);
}

export function* updateInventoryProviderRequest() {
  yield takeLatest(actions.UPDATE_INVENTORY_PROVIDER_REQUEST, function* (action) {
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(updateProviderOnDB, action.payload.id, action.payload.item, currentAddress, mainUser);
      yield put({
        type: actions.INVENTORY_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.UPDATE_INVENTORY_PROVIDER_ERROR,
      });
    }
  });
}

function getProviderHistoryFromDB(providerId, currentAddress, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const opsQuery = dbQuery(
    ref(db, `inventory/${uid}/${currentAddress}/ops`),
    orderByChild('provider'),
    equalTo(providerId),
    limitToLast(PROVIDER_HISTORY_LIMIT),
  );
  return get(opsQuery);
}

export function* fetchProviderHistoryRequest() {
  yield takeLatest(actions.PROVIDER_HISTORY_FETCH_REQUEST, function* (action) {
    try {
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const ops = yield call(getProviderHistoryFromDB, action.payload, currentAddress, mainUser);
      yield put({
        type: actions.PROVIDER_HISTORY_FETCH_SUCCESS,
        payload: {
          providerId: action.payload,
          ops: _.map(ops.val() || {}, (val, opId) => ({ ...val, id: opId })),
        },
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.PROVIDER_HISTORY_FETCH_ERROR,
      });
    }
  });
}

function createFinancialContactOnDB(contactValues, addressUid, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const values = typeof contactValues === 'string' ? { name: contactValues } : contactValues;
  const contactObject = {
    name: values.name,
    timestamp: moment().tz('America/Sao_Paulo').format(),
  };
  if (values.type) {
    contactObject.type = values.type;
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/financial/${uid}/${addressUid}/contacts`)).key;
  updates[`/financial/${uid}/${addressUid}/contacts/${pushKey}`] = contactObject;
  return update(dbRef, updates);
}

function withdrawInventoryItemOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  const auth = getAuth();
  const { currentUser } = auth;
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  const updates = {};
  if (values.products) {
    const pushKey = push(child(ref(db), `/inventory/${uid}/${currentAddress}/ops`)).key;
    updates[`/inventory/${uid}/${currentAddress}/ops/${pushKey}`] = {
      ...values,
      type: 'withdraw',
      user: currentUser.uid,
    };
    if (values.patient) {
      updates[`/users/${uid}/inventoryHistory/${values.patient}/${pushKey}`] = {
        address: currentAddress,
        type: 'withdraw',
      };
    }
  } else {
    throw new Error('No products!');
  }
  // return true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* withdrawInventoryItemRequest() {
  yield takeLatest(actions.WITHDRAW_INVENTORY_ITEM_REQUEST, function* (action) {
    const currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.WAITING_INVENTORY_OPS });
      const mainUser = yield select(getMainUserFromStore);
      const payloadObject = {
        ...action.payload,
      };
      if (action.payload.selectedFinancialContact) {
        // Fetch again the list to make sure it is updated.
        yield put({
          type: financialActions.GET_FINANCIAL_CONTACTS_REQUEST,
        });
        yield take(financialActions.GET_FINANCIAL_CONTACTS_SUCCESS);
        let contactsList = yield select(getFinancialContactsFromStore);
        let foundContact = contactsList.find((el) => (
          el.id === action.payload.selectedFinancialContact || el.name === action.payload.selectedFinancialContact
        ));
        if (!foundContact) {
          // It is a new payer.
          yield call(
            createFinancialContactOnDB,
            { name: action.payload.selectedFinancialContact, type: 'client' },
            currentAddress,
            mainUser,
          );
          yield put({
            type: financialActions.GET_FINANCIAL_CONTACTS_REQUEST,
          });
          yield take(financialActions.GET_FINANCIAL_CONTACTS_SUCCESS);
          contactsList = yield select(getFinancialContactsFromStore);
          foundContact = contactsList.find((el) => (
            el.id === action.payload.selectedFinancialContact || el.name === action.payload.selectedFinancialContact
          ));
        }
        payloadObject.selectedFinancialContact = foundContact.id;
      }
      yield call(
        withdrawInventoryItemOnDB,
        payloadObject,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.WITHDRAW_INVENTORY_ITEM_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.WITHDRAW_INVENTORY_ITEM_ERROR,
      });
    }
  });
}

function updateInventoryDepositOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  // const updates = {};
  let obj = {};
  if (values.products && values.products.length > 0) {
    obj = {
      ...values,
      id: null,
      // products: null,
      // itemId: values.products[0].id,
      transactionsArr: null,
    };
    // values.products.forEach((el) => {
    //   updates[`/inventory/${uid}/${currentAddress}/ops/${values.id}`] = {
    //     ...values,
    //     ...el,
    //     id: null,
    //     products: null,
    //     itemId: el.id,
    //   };
    // });
  } else {
    throw new Error('No products!');
  }
  return update(ref(db, `/inventory/${uid}/${currentAddress}/ops/${values.id}`), obj);
}

export function* updateInventoryDepositRequest() {
  yield takeLatest(actions.UPDATE_INVENTORY_DEPOSIT_REQUEST, function* (action) {
    const currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.WAITING_INVENTORY_OPS });
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        updateInventoryDepositOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.DEPOSIT_INVENTORY_ITEM_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.UPDATE_INVENTORY_DEPOSIT_ERROR,
      });
    }
  });
}

function cancelOperationOnDB(key, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/inventory/${uid}/${currentAddress}/ops/${key}/canceled`] = true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* cancelOperationRequest() {
  yield takeLatest(actions.CANCEL_OPERATION_REQUEST, function* (action) {
    try {
      yield put({
        type: actions.CANCEL_OPERATION_WAITING,
        payload: action.payload,
      });
      yield call(sleep, 500);
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(cancelOperationOnDB, action.payload, currentAddress, mainUser);
      yield put({
        type: actions.INVENTORY_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CANCEL_OPERATION_ERROR,
      });
    }
  });
}

function updateWithdrawInventoryOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  // const updates = {};
  // updates[`/inventory/${uid}/${currentAddress}/ops/${values.id}`] = {
  //   ...values,
  //   id: null,
  //   // type: 'withdraw',
  // };
  let obj = {};
  if (values.products && values.products.length > 0) {
    obj = {
      ...values,
      id: null,
      // products: null,
      // itemId: values.products[0].id,
      transactionsArr: null,
    };
    // values.products.forEach((el) => {
    //   updates[`/inventory/${uid}/${currentAddress}/ops/${values.id}`] = {
    //     ...values,
    //     ...el,
    //     id: null,
    //     products: null,
    //     itemId: el.id,
    //   };
    // });
  } else {
    throw new Error('No products!');
  }
  return update(ref(db, `/inventory/${uid}/${currentAddress}/ops/${values.id}`), obj);
}

export function* updateWithdrawInventoryRequest() {
  yield takeLatest(actions.UPDATE_INVENTORY_WITHDRAW_REQUEST, function* (action) {
    const currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.WAITING_INVENTORY_OPS });
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        updateWithdrawInventoryOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.WITHDRAW_INVENTORY_ITEM_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.UPDATE_INVENTORY_WITHDRAW_ERROR,
      });
    }
  });
}

function createClassOnDB(item, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/inventory/${uid}/${currentAddress}/classes`)).key;
  updates[`/inventory/${uid}/${currentAddress}/classes/${pushKey}`] = item;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* createInventoryClassRequest() {
  yield takeLatest(actions.CREATE_INVENTORY_CLASS_REQUEST, function* (action) {
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(createClassOnDB, action.payload, currentAddress, mainUser);
      yield put({
        type: actions.INVENTORY_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_INVENTORY_CLASS_ERROR,
      });
    }
  });
}

function removeInventoryClassOnDB(key, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/inventory/${uid}/${currentAddress}/classes/${key}/disabled`] = true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* removeInventoryClassRequest() {
  yield takeLatest(actions.REMOVE_INVENTORY_CLASS_REQUEST, function* (action) {
    const currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      const mainUser = yield select(getMainUserFromStore);
      yield call(removeInventoryClassOnDB, action.payload, currentAddress, mainUser);
      yield put({
        type: actions.INVENTORY_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.REMOVE_INVENTORY_CLASS_ERROR,
      });
    }
  });
}

function updateClassOnDB(key, item, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  // Campo a campo: um write do objeto inteiro apagaria timestamp e disabled.
  const path = `/inventory/${uid}/${currentAddress}/classes/${key}`;
  updates[`${path}/name`] = item.name;
  updates[`${path}/description`] = item.description || null;
  updates[`${path}/color`] = item.color || null;
  return update(dbRef, updates);
}

export function* updateInventoryClassRequest() {
  yield takeLatest(actions.UPDATE_INVENTORY_CLASS_REQUEST, function* (action) {
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(updateClassOnDB, action.payload.id, action.payload.item, currentAddress, mainUser);
      yield put({
        type: actions.INVENTORY_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.UPDATE_INVENTORY_CLASS_ERROR,
      });
    }
  });
}

function updateInventoryOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  let obj = {};
  obj = {
    ...values,
    id: null,
  };
  return update(ref(db, `/inventory/${uid}/${currentAddress}/items/${values.id}`), obj);
  // return new Promise((resolve, reject) => {
  //   db.ref(`/inventory/${uid}/${currentAddress}/items/${values.id}`).update(obj, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* updateInventoryItemRequest() {
  yield takeLatest(actions.UPDATE_INVENTORY_ITEM_REQUEST, function* (action) {
    try {
      yield put({ type: actions.INVENTORY_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(updateInventoryOnDB, action.payload, currentAddress, mainUser);
      yield put({
        type: actions.INVENTORY_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.UPDATE_INVENTORY_ITEM_ERROR,
      });
    }
  });
}

function updateFinalizedAppointmentProceduresArrFromInventoryOnDB(
  proceduresArr,
  totalItemsUsed,
  finalizeAppointment,
  currentAddress,
  mainUser,
  warehouseId,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/finalizedAppointments/${uid}/${currentAddress}/${finalizeAppointment.id}/proceduresArr`] = proceduresArr;
  updates[`/finalizedAppointments/${uid}/${currentAddress}/${finalizeAppointment.id}/totalItemsUsed`] = totalItemsUsed;
  if (warehouseId) {
    updates[`/finalizedAppointments/${uid}/${currentAddress}/${finalizeAppointment.id}/warehouseId`] = warehouseId;
  }
  return update(dbRef, updates);
}

export function* updateFinalizedAppointmentProceduresArrFromInventoryRequest() {
  yield takeLatest(actions.UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_REQUEST, function* (action) {
    try {
      yield put({ type: actions.SAVING_FINALIZED_APPOINTMENT_FROM_INVENTORY });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const { proceduresArr, totalItemsUsed, warehouseId } = action.payload;
      yield call(
        updateFinalizedAppointmentProceduresArrFromInventoryOnDB,
        proceduresArr,
        totalItemsUsed,
        action.payload.finalizeAppointment,
        currentAddress,
        mainUser,
        warehouseId,
      );
      yield put({
        type: actions.UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_ERROR,
      });
    }
  });
}

function updateItemSellValueOnDB(
  value,
  itemId,
  currentAddress,
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`inventory/${uid}/${currentAddress}/items/${itemId}/sellValue`] = value;
  return update(dbRef, updates);
}

export function* updateItemSellValueRequest() {
  yield takeLatest(actions.SAVE_ITEM_SELL_VALUE_REQUEST, function* (action) {
    try {
      const { value, itemId } = action.payload;
      yield put({
        type: actions.SAVING_ITEM_SELL_VALUE,
        payload: itemId,
      });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        updateItemSellValueOnDB,
        value,
        itemId,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.SAVE_ITEM_SELL_VALUE_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.SAVE_ITEM_SELL_VALUE_ERROR,
      });
    }
  });
}

// ---------------------------------------------------------------------------
// Warehouses listener
// ---------------------------------------------------------------------------
function createInventoryWarehousesListener(addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `inventory/${uid}/${addressUid}/warehouses`);
    const unsubscribe = onValue(databaseRef, (snap) => emit(snap.val() || 0));
    return () => unsubscribe();
  });
  return listener;
}

export function* getInventoryWarehousesRequest() {
  let currentListener = null;
  yield takeLatest(actions.INVENTORY_ITEMS_LISTENER_REQUEST, function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    try {
      if (currentListener) {
        currentListener.close();
        currentListener = null;
      }
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      if (!getAuth().currentUser) return;
      currentListener = yield call(createInventoryWarehousesListener, currentAddress, mainUser);
      yield takeEvery(currentListener, function* (data) {
        const inventoryWarehouses = data
          ? _.map(data, (val, id) => ({ ...val, id }))
          : [];
        yield put({
          type: actions.INVENTORY_WAREHOUSES_FETCH_SUCCESS,
          payload: { inventoryWarehouses },
        });
      });
      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        authActions.LOGOUT,
        authActions.CLEAR_STATES,
      ]);
      currentListener.close();
      currentListener = null;
      if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
        // Address change: selectAddress resubscribes via removeListeners.
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_INVENTORY_LISTENER }),
        ]);
      }
      // LOGOUT/CLEAR_STATES: keep listeners closed.
    } catch (error) {
      console.warn(error);
    }
  });
}

// ---------------------------------------------------------------------------
// On-demand batch metadata loader (replaces real-time batches/ listener)
// ---------------------------------------------------------------------------
function fetchBatchesByIds(batchIds, addressUid, uid) {
  const db = getDatabase();
  return Promise.all(
    batchIds.map((id) => get(ref(db, `inventory/${uid}/${addressUid}/batches/${id}`))),
  ).then((snaps) => snaps
    .map((snap, i) => (snap.exists() ? { id: batchIds[i], ...snap.val() } : null))
    .filter(Boolean));
}

// ---------------------------------------------------------------------------
// Stock listener: stock/{whId}/{itemId}/{batchId}/amount → flat array
// ---------------------------------------------------------------------------
function createInventoryStockListener(addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `inventory/${uid}/${addressUid}/stock`);
    const unsubscribe = onValue(databaseRef, (snap) => emit(snap.val() || 0));
    return () => unsubscribe();
  });
  return listener;
}

export function* getInventoryStockRequest() {
  let currentListener = null;
  yield takeLatest(actions.INVENTORY_ITEMS_LISTENER_REQUEST, function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    try {
      if (currentListener) {
        currentListener.close();
        currentListener = null;
      }
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      if (!getAuth().currentUser) return;
      const uid = mainUser || getAuth().currentUser.uid;
      currentListener = yield call(createInventoryStockListener, currentAddress, mainUser);
      yield takeEvery(currentListener, function* (data) {
        const inventoryStock = [];
        if (data && data !== 0) {
          Object.entries(data).forEach(([whId, byItem]) => {
            if (!byItem) return;
            Object.entries(byItem).forEach(([itemId, byBatch]) => {
              if (!byBatch) return;
              Object.entries(byBatch).forEach(([batchId, batchData]) => {
                if (!batchData) return;
                inventoryStock.push({
                  whId,
                  itemId,
                  batchId,
                  amount: new Big(batchData.amount || 0).div(1000).toNumber(),
                });
              });
            });
          });
        }
        yield put({
          type: actions.INVENTORY_STOCK_FETCH_SUCCESS,
          payload: { inventoryStock },
        });

        const currentItems = yield select(getInventoryItemsFromStore);
        if (Array.isArray(currentItems) && currentItems.length > 0) {
          const patchedItems = currentItems.map((item) => ({
            ...item,
            amount: computeItemAmountFromStock(item.id, inventoryStock),
          }));
          yield put({
            type: actions.INVENTORY_ITEMS_FETCH_SUCCESS,
            payload: { inventoryItems: patchedItems },
          });
        }

        // Carregar metadata dos batches ativos ainda não em cache
        const activeBatchIds = [...new Set(
          inventoryStock.filter((l) => l.amount !== 0).map((l) => l.batchId),
        )];
        const cachedBatches = yield select(getInventoryNewBatchesFromStore);
        const cachedIds = new Set(cachedBatches.map((b) => b.id));
        const missingIds = activeBatchIds.filter((id) => !cachedIds.has(id));
        if (missingIds.length > 0) {
          const fetched = yield call(fetchBatchesByIds, missingIds, currentAddress, uid);
          if (fetched.length > 0) {
            const merged = [
              ...cachedBatches.map((b) => {
                const updated = fetched.find((n) => n.id === b.id);
                return updated ? { ...b, ...updated } : b;
              }),
              ...fetched.filter((n) => !cachedIds.has(n.id)),
            ];
            yield put({
              type: actions.INVENTORY_NEW_BATCHES_FETCH_SUCCESS,
              payload: { inventoryNewBatches: merged },
            });
          }
        }
      });
      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        authActions.LOGOUT,
        authActions.CLEAR_STATES,
      ]);
      currentListener.close();
      currentListener = null;
      if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
        // Address change: selectAddress resubscribes via removeListeners.
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_INVENTORY_LISTENER }),
        ]);
      }
      // LOGOUT/CLEAR_STATES: keep listeners closed.
    } catch (error) {
      console.warn(error);
    }
  });
}

// ---------------------------------------------------------------------------
// Create warehouse
// ---------------------------------------------------------------------------
// Rebaixa os principais atuais no mesmo update: a troca de principal é atômica
// e a lista nunca fica com dois selos.
function buildDefaultDemotions(warehouses, uid, currentAddress, keptId) {
  const demotions = {};
  (warehouses || []).forEach((warehouse) => {
    if (!warehouse.isDefault || warehouse.id === keptId) return;
    demotions[`inventory/${uid}/${currentAddress}/warehouses/${warehouse.id}/isDefault`] = false;
  });
  return demotions;
}

function createWarehouseOnDB(values, currentAddress, mainUser, warehouses) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const makeDefault = values.isDefault === true;
  const pushKey = push(child(ref(db), `inventory/${uid}/${currentAddress}/warehouses`)).key;
  updates[`inventory/${uid}/${currentAddress}/warehouses/${pushKey}`] = {
    ...values,
    isDefault: makeDefault,
    disabled: false,
    timestamp: moment().tz('America/Sao_Paulo').format(),
  };
  if (makeDefault) {
    Object.assign(updates, buildDefaultDemotions(warehouses, uid, currentAddress, pushKey));
  }
  return update(dbRef, updates);
}

export function* createWarehouseRequest() {
  yield takeLatest(actions.CREATE_WAREHOUSE_REQUEST, function* (action) {
    try {
      yield put({ type: actions.CREATING_WAREHOUSE });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const warehouses = yield select(getInventoryWarehousesFromStore);
      yield call(createWarehouseOnDB, action.payload, currentAddress, mainUser, warehouses);
      yield put({ type: actions.CREATE_WAREHOUSE_SUCCESS });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.CREATE_WAREHOUSE_ERROR });
    }
  });
}

// ---------------------------------------------------------------------------
// Update warehouse (disable/enable/rename)
// ---------------------------------------------------------------------------
function updateWarehouseOnDB(id, values, currentAddress, mainUser, warehouses) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  Object.keys(values).forEach((key) => {
    updates[`inventory/${uid}/${currentAddress}/warehouses/${id}/${key}`] = values[key];
  });
  if (values.isDefault === true) {
    Object.assign(updates, buildDefaultDemotions(warehouses, uid, currentAddress, id));
  }
  return update(dbRef, updates);
}

export function* updateWarehouseRequest() {
  yield takeLatest(actions.UPDATE_WAREHOUSE_REQUEST, function* (action) {
    const { id, values } = action.payload;
    try {
      yield put({ type: actions.UPDATING_WAREHOUSE, payload: id });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const warehouses = yield select(getInventoryWarehousesFromStore);
      yield call(updateWarehouseOnDB, id, values, currentAddress, mainUser, warehouses);
      yield put({ type: actions.UPDATE_WAREHOUSE_SUCCESS });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.UPDATE_WAREHOUSE_ERROR });
    }
  });
}

// ---------------------------------------------------------------------------
// Transfer inventory between warehouses
// ---------------------------------------------------------------------------
function transferInventoryOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  const auth = getAuth();
  const { currentUser } = auth;
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `inventory/${uid}/${currentAddress}/ops`)).key;
  updates[`inventory/${uid}/${currentAddress}/ops/${pushKey}`] = {
    ...values,
    type: 'transfer',
    user: currentUser.uid,
    timestamp: moment().tz('America/Sao_Paulo').format(),
  };
  return update(dbRef, updates);
}

export function* transferInventoryRequest() {
  yield takeLatest(actions.TRANSFER_INVENTORY_REQUEST, function* (action) {
    try {
      yield put({ type: actions.WAITING_INVENTORY_OPS });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(transferInventoryOnDB, action.payload, currentAddress, mainUser);
      yield put({ type: actions.TRANSFER_INVENTORY_SUCCESS });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.TRANSFER_INVENTORY_ERROR });
    }
  });
}

function updateTransferInventoryOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  if (!values.products || values.products.length === 0) {
    throw new Error('No products!');
  }
  const obj = { ...values, id: null };
  return update(ref(db, `/inventory/${uid}/${currentAddress}/ops/${values.id}`), obj);
}

export function* updateTransferInventoryRequest() {
  yield takeLatest(actions.UPDATE_TRANSFER_INVENTORY_REQUEST, function* (action) {
    try {
      yield put({ type: actions.WAITING_INVENTORY_OPS });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(updateTransferInventoryOnDB, action.payload, currentAddress, mainUser);
      yield put({ type: actions.TRANSFER_INVENTORY_SUCCESS });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.TRANSFER_INVENTORY_ERROR });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getInventorySettingsRequest),
    fork(changeInvoiceAutomationRequest),
    fork(changeShowFinalizedAppointmentModalRequest),
    fork(getInventoryItemsRequest),
    fork(getInventoryItemsBatchesRequest),
    fork(getInventoryWarehousesRequest),
    fork(getInventoryStockRequest),
    fork(getInventoryOpsRequest),
    fork(getInventoryProvidersRequest),
    fork(getInventoryClassesRequest),
    fork(createInventoryItemRequest),
    fork(removeInventoryRequest),
    fork(depositInventoryItemRequest),
    fork(createInventoryProviderRequest),
    fork(removeInventoryProviderRequest),
    fork(updateInventoryProviderRequest),
    fork(fetchProviderHistoryRequest),
    fork(withdrawInventoryItemRequest),
    fork(updateInventoryDepositRequest),
    fork(cancelOperationRequest),
    fork(updateWithdrawInventoryRequest),
    fork(createInventoryClassRequest),
    fork(removeInventoryClassRequest),
    fork(updateInventoryClassRequest),
    fork(updateInventoryItemRequest),
    fork(updateFinalizedAppointmentProceduresArrFromInventoryRequest),
    fork(updateItemSellValueRequest),
    fork(createWarehouseRequest),
    fork(updateWarehouseRequest),
    fork(transferInventoryRequest),
    fork(updateTransferInventoryRequest),
  ]);
}
